import api from '@/libs/api'
import store from '@/store'
import helperMixin from '@/mixins/helpers'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    // BEHAVIORS
    behaviors: [],
    behaviorsResultInfo: {},
    behaviorsCurrentPage: 1,
    behavior: {},
    behaviorOriginRequestPolicyOptions: [],
    behaviorCachePolicyOptions: [],
    fetchingBehaviors: false,
    gettingBehavior: false,
    updatingBehavior: false,
    removingBehavior: false,
    addingBehavior: false,

    // CERTIFICATES
    certificates: [],
    certificate: {},
    importingCertificate: false,
    fetchingCertificates: false,
    fetchingSniCertificates: false,
    sniCertificates: [],
    autovalidatableDomains: [],
    validatingCertificate: false,
    addingCertificate: false,
    removingCertificate: false,
    updatingCertificate: false,
    gettingCertificate: false,
    downloadingCertificate: false,
    syncingCertificate: false,
    certificatesResultInfo: {},
    certificatesCurrentPage: 1,

    // DISTRIBUTIONS
    distributions: [],
    distributionsResultInfo: {},
    scrolledDistributions: [],
    scrolledDistributionsResultInfo: {},
    distribution: [],
    newDistribution: null,
    fetchingDistributions: false,
    fetchingScrolledDistributions: false,
    addingDistribution: false,
    gettingDistribution: false,
    removingDistribution: false,
    updatingDistribution: false,
    updatingDistributionState: false,

    // ERROR PAGES
    errorpages: [],
    errorpage: {},
    fetchingErrorpages: false,
    gettingErrorpage: false,
    updatingErrorpage: false,
    removingErrorpage: false,
    addingErrorpage: false,

    // INVALIDATIONS
    invalidations: [],
    invalidationsResultInfo: {},
    invalidation: {},
    fetchingInvalidations: false,
    gettingInvalidation: false,
    addingInvalidation: false,

    // ORIGINS
    origins: [],
    origin: {},
    fetchingOrigins: false,
    gettingOrigin: false,
    updatingOrigin: false,
    removingOrigin: false,
    addingOrigin: false,

    // ORIGIN GROUPS
    origingroups: [],
    origingroup: {},
    fetchingOriginGroups: false,
    gettingOriginGroup: false,
    updatingOriginGroup: false,
    removingOriginGroup: false,
    addingOriginGroup: false,

    // HEALTHCHECKS
    healthchecks: [],
    healthcheck: {},
    fetchingHealthchecks: false,
    gettingHealthcheck: false,
    updatingHealthcheck: false,
    removingHealthcheck: false,
    addingHealthcheck: false,

    // RESTRICTIONS
    restrictions: [],
    restriction: {},
    fetchingRestrictions: false,
    creatingRestriction: false,
    updatingRestriction: false,
    deletingRestriction: false,

    // TAGS
    tags: [],
    tag: {},
    fetchingTags: false,
    updatingTags: false,
    addingTags: false,
  },
  getters: {
    projectId: () => store.state.app.projectId,
    getDistribution: state => id => state.distributions.find(
      distribution => distribution.distributionId === id,
    ),
    firstDistributionId: state => (state.distributions.length ? state.distributions[0].distributionId : null),
    distributionsSize: state => state.distributions.length,
    behaviorsCurrentPage: state => state.behaviorsCurrentPage,
    certificatesCurrentPage: state => state.certificatesCurrentPage,
  },
  mutations: {
    // loading
    SET_LOADING(state, value) {
      state.loading = value
    },

    // BEHAVIORS
    SET_BEHAVIORS(state, data) {
      state.behaviors = data.result
      state.behaviorsResultInfo = data.resultInfo
    },
    GET_BEHAVIOR(state, behavior) {
      state.behavior = behavior
    },
    GET_BEHAVIOR_POLICIES(state, behavior) {
      state.behaviorOriginRequestPolicyOptions = behavior.originRequestPolicyOptions
      state.behaviorCachePolicyOptions = behavior.cachePolicyOptions
      state.behavior.cachePolicyOptions = behavior.cachePolicyOptions
      state.behavior.originRequestPolicyOptions = behavior.originRequestPolicyOptions
    },
    SET_FETCHING_BEHAVIORS(state, value) {
      state.fetchingBehaviors = value
    },
    SET_ADDING_BEHAVIOR(state, value) {
      state.addingBehavior = value
    },
    SET_UPDATING_BEHAVIOR(state, value) {
      state.updatingBehavior = value
    },
    SET_REMOVING_BEHAVIOR(state, value) {
      state.removingBehavior = value
    },
    REMOVE_BEHAVIOR(state, id) {
      state.behaviors = state.behaviors.filter(b => b.id !== id)
    },
    SET_GETTING_BEHAVIOR(state, value) {
      state.gettingBehavior = value
    },
    SET_BEHAVIORS_CURRENT_PAGE(state, value) {
      state.behaviorsCurrentPage = value
    },

    // CERTIFICATES
    SET_CERTIFICATES(state, data) {
      state.certificates = data.result
      state.certificatesResultInfo = data.resultInfo
    },
    SET_SNI_CERTIFICATES(state, data) {
      state.sniCertificates = data.result
    },
    SET_AUTOVALIDATABLE_DOMAINS(state, data) {
      state.autovalidatableDomains = data.result
    },
    GET_CERTIFICATE(state, certificate) {
      state.certificate = certificate
    },
    UPDATE_CERTIFICATE(state, certificate) {
      state.certificates.find(c => c.id === certificate.id).scope = certificate.scope
    },
    SET_FETCHING_CERTIFICATES(state, value) {
      state.fetchingCertificates = value
    },
    SET_FETCHING_SNI_CERTIFICATES(state, value) {
      state.fetchingSniCertificates = value
    },
    SET_ADDING_CERTIFICATE(state, value) {
      state.addingCertificate = value
    },
    SET_UPDATING_CERTIFICATE(state, value) {
      state.updatingCertificate = value
    },
    SET_REMOVING_CERTIFICATE(state, value) {
      state.removingCertificate = value
    },
    REMOVE_CERTIFICATE(state, id) {
      state.certificates = state.certificates.filter(c => c.id !== id)
    },
    SET_GETTING_CERTIFICATE(state, value) {
      state.gettingCertificate = value
    },
    SET_DOWNLOADING_CERTIFICATE(state, value) {
      state.downloadingCertificate = value
    },
    SET_IMPORTING_CERTIFICATE(state, value) {
      state.importingCertificate = value
    },
    SET_VALIDATING_CERTIFICATE(state, value) {
      state.validatingCertificate = value
    },
    UPDATE_CERTIFICATE_STATUS(state, item) {
      const itemIndex = state.certificates.findIndex(el => el.id === item.id)
      if (state.certificates[itemIndex]) {
        state.certificates[itemIndex].certificateStatus = item.certificateStatus
      }
    },
    SET_SYNCING_CERTIFICATE(state, value) {
      state.syncingCertificate = value
    },
    SET_CERTIFICATES_CURRENT_PAGE(state, value) {
      state.certificatesCurrentPage = value
    },

    // DISTRIBUTIONS
    SET_DISTRIBUTIONS(state, data) {
      state.distributions = data.result
      state.distributionsResultInfo = data.resultInfo
    },
    PUSH_DISTRIBUTIONS(state, data) {
      const newDistributions = [...data.result]
      state.scrolledDistributions.forEach(distribution => {
        const existingDistribution = newDistributions.find(d => d.distributionId === distribution.distributionId)
        if (!existingDistribution) {
          newDistributions.push(distribution)
        }
      })
      state.scrolledDistributions = newDistributions
      state.scrolledDistributionsResultInfo = data.resultInfo
    },
    GET_DISTRIBUTION(state, distribution) {
      state.distribution = distribution
    },
    SET_FETCHING_DISTRIBUTION(state, value) {
      state.fetchingDistributions = value
    },
    SET_FETCHING_SCROLLED_DISTRIBUTION(state, value) {
      state.fetchingScrolledDistributions = value
    },
    SET_ADDING_DISTRIBUTION(state, value) {
      state.addingDistribution = value
    },
    SET_GETTING_DISTRIBUTION(state, value) {
      state.gettingDistribution = value
    },
    SET_REMOVING_DISTRIBUTION(state, value) {
      state.removingDistribution = value
    },
    REMOVE_DISTRIBUTION(state, id) {
      state.distributions = state.distributions.filter(
        d => d.distributionId !== id,
      )
    },
    SET_UPDATING_DISTRIBUTION(state, value) {
      state.updatingDistribution = value
    },
    SET_NEW_DISTRIBUTION(state) {
      state.newDistribution = {
        projectId: '',
        stateId: 1,
        alternateDomainNames: '',
        sslCertificateId: null,
        sslCertificateType: null,
        supportedHttpVersions: 0,
        securityPolicyId: 0,
        defaultRootObject: '',
        ipv6: true,
        comment: '',
        domainName: '',
        originPath: '',
        originId: '',
        customHeaders: [],
        pathPattern: '*',
        allowedHttpMethods: 0,
        cachedHttpMethods: 0,
        cachePolicyId: 0,
        originRequestPolicyId: 0,
        wafSetting: 0,
        minimumOriginSslProtocol: 0,
        originProtocolPolicy: 0,
        httpPort: 80,
        httpsPort: 443,
      }
    },
    SET_UPDATING_DISTRIBUTION_STATE(state, value) {
      state.updatingDistributionState = value
    },
    UPDATE_DISTRIBUTION_STATE(state, dist) {
      const index = state.distributions.findIndex(
        el => el.distributionId === dist.distributionId,
      )
      state.distributions[index].state = dist.state
      state.distributions[index].status = dist.distributionStatusOptions.find(
        o => o.id === dist.distributionStatus,
      ).value
      state.distributions[index].lastModified = dist.lastModified.endsWith('Z')
        ? dist.lastModified.slice(0, dist.lastModified.length - 1)
        : dist.lastModified
    },

    // ERROR PAGES
    SET_ERRORPAGES(state, data) {
      state.errorpages = data.result
    },
    GET_ERRORPAGE(state, errorpage) {
      state.errorpage = errorpage
    },
    SET_FETCHING_ERRORPAGES(state, value) {
      state.fetchingErrorpages = value
    },
    SET_ADDING_ERRORPAGE(state, value) {
      state.addingErrorpage = value
    },
    SET_UPDATING_ERRORPAGE(state, value) {
      state.updatingErrorpage = value
    },
    SET_REMOVING_ERRORPAGE(state, value) {
      state.removingErrorpage = value
    },
    REMOVE_ERRORPAGE(state, id) {
      state.errorpages = state.errorpages.filter(e => e.id !== id)
    },
    SET_GETTING_ERRORPAGE(state, value) {
      state.gettingErrorpage = value
    },

    // INVALIDATIONS
    SET_INVALIDATIONS(state, data) {
      state.invalidations = data.result
      state.invalidationsResultInfo = data.resultInfo
    },
    SET_FETCHING_INVALIDATIONS(state, value) {
      state.fetchingInvalidations = value
    },
    GET_INVALIDATION(state, invalidation) {
      state.invalidation = invalidation
    },
    SET_ADDING_INVALIDATION(state, value) {
      state.addingInvalidation = value
    },
    SET_GETTING_INVALIDATION(state, value) {
      state.gettingInvalidation = value
    },
    ADD_INVALIDATION(state, data) {
      const status = data.statusOptions.find(s => s.id === data.statusId)?.value
      state.invalidations.unshift({
        createdAt: data.createdAt,
        completedAt: data.completedAt,
        invalidationId: data.invalidationId,
        status,
      })
      if (state.invalidations.length > state.invalidationsResultInfo.pageSize) {
        state.invalidations.pop()
      }
      state.invalidationsResultInfo.totalCount++
      state.invalidationsResultInfo.hasNextPage = state.invalidationsResultInfo.totalCount
        > state.invalidationsResultInfo.pageSize
    },

    // ORIGINS
    SET_ORIGINS(state, data) {
      state.origins = data.result
    },
    GET_ORIGIN(state, origin) {
      state.origin = origin
    },
    SET_FETCHING_ORIGINS(state, value) {
      state.fetchingOrigins = value
    },
    SET_ADDING_ORIGIN(state, value) {
      state.addingOrigin = value
    },
    SET_UPDATING_ORIGIN(state, value) {
      state.updatingOrigin = value
    },
    SET_REMOVING_ORIGIN(state, value) {
      state.removingOrigin = value
    },
    REMOVE_ORIGIN(state, id) {
      state.origins = state.origins.filter(o => o.id !== id)
    },
    SET_GETTING_ORIGIN(state, value) {
      state.gettingOrigin = value
    },

    // ORIGIN GROUPS
    SET_ORIGINGROUPS(state, data) {
      state.origingroups = data.result
    },
    GET_ORIGINGROUP(state, origingroup) {
      state.origingroup = origingroup
    },
    SET_FETCHING_ORIGINGROUPS(state, value) {
      state.fetchingOriginGroups = value
    },
    SET_ADDING_ORIGINGROUP(state, value) {
      state.addingOriginGroup = value
    },
    SET_UPDATING_ORIGINGROUP(state, value) {
      state.updatingOriginGroup = value
    },
    SET_REMOVING_ORIGINGROUP(state, value) {
      state.removingOriginGroup = value
    },
    REMOVE_ORIGINGROUP(state, id) {
      state.origingroups = state.origingroups.filter(o => o.id !== id)
    },
    SET_GETTING_ORIGINGROUP(state, value) {
      state.gettingOriginGroup = value
    },

    // HEALTHCHECKS
    SET_HEALTHCHECKS(state, data) {
      state.healthchecks = data.result
    },
    GET_HEALTHCHECK(state, healthcheck) {
      state.healthcheck = healthcheck
    },
    SET_FETCHING_HEALTHCHECKS(state, value) {
      state.fetchingHealthchecks = value
    },
    SET_ADDING_HEALTHCHECK(state, value) {
      state.addingHealthcheck = value
    },
    SET_UPDATING_HEALTHCHECK(state, value) {
      state.updatingHealthcheck = value
    },
    SET_REMOVING_HEALTHCHECK(state, value) {
      state.removingHealthcheck = value
    },
    SET_GETTING_HEALTHCHECK(state, value) {
      state.gettingHealthcheck = value
    },
    REMOVE_HEALTHCHECK(state, id) {
      state.healthchecks = state.healthchecks.filter(el => el.id !== id)
    },

    // RESTRICTIONS
    SET_RESTRICTIONS(state, data) {
      state.restrictions = data || []
    },
    ADD_RESTRICTION(state) {
      state.loading = false
    },
    UPDATE_RESTRICTION(state) {
      state.loading = false
    },
    REMOVE_RESTRICTION(state) {
      state.loading = false
    },
    GET_RESTRICTION(state, restriction) {
      state.restriction = restriction
      state.loading = false
    },
    SET_CREATING_RESTRICTION(state, value) {
      state.creatingRestriction = value
    },
    SET_UPDATING_RESTRICTION(state, value) {
      state.updatingRestriction = value
    },
    SET_DELETING_RESTRICTION(state, value) {
      state.deletingRestriction = value
    },

    // TAGS
    SET_TAGS(state, data) {
      state.tags = data
    },
    SET_FETCHING_TAGS(state, value) {
      state.fetchingTags = value
    },
    SET_UPDATING_TAGS(state, value) {
      state.updatingTags = value
    },
    REMOVE_TAG(state) {
      state.loading = false
    },
    GET_TAG(state, tag) {
      state.tag = tag
    },
  },
  actions: {
    // BEHAVIORS
    fetchBehaviors({ commit }, query) {
      commit('SET_FETCHING_BEHAVIORS', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${
              query.id
            }/behaviors?PageIndex=${query.pageIndex}&PageSize=${
              query.pageSize
            }`,
          )
          .then(response => {
            commit('SET_BEHAVIORS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_BEHAVIORS', false)
          })
      })
    },

    updateBehaviors({ commit }, query) {
      commit('SET_UPDATING_BEHAVIOR', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .put(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/behaviors/`,
            { behaviors: query.behaviors },
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_BEHAVIOR', false)
          })
      })
    },

    addBehavior({ commit }, query) {
      commit('SET_ADDING_BEHAVIOR', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .post(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/behaviors`,
            query,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_ADDING_BEHAVIOR', false)
          })
      })
    },

    updateBehavior({ commit }, query) {
      commit('SET_UPDATING_BEHAVIOR', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .put(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/behaviors/${query.id}`,
            query,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_BEHAVIOR', false)
          })
      })
    },

    removeBehavior({ commit }, query) {
      commit('SET_REMOVING_BEHAVIOR', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .delete(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/behaviors/${query.id}`,
          )
          .then(response => {
            commit('REMOVE_BEHAVIOR', query.id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_REMOVING_BEHAVIOR', false)
          })
      })
    },

    getBehavior({ commit }, query) {
      commit('SET_GETTING_BEHAVIOR', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/behaviors/${query.id}`,
          )
          .then(response => {
            commit('GET_BEHAVIOR', response.data.result)
            commit('GET_BEHAVIOR_POLICIES', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_BEHAVIOR', false)
          })
      })
    },

    getBehaviorPolicies({ commit }, query) {
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/behaviors/${query.id}`,
          )
          .then(response => {
            commit('GET_BEHAVIOR_POLICIES', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // CERTIFICATES
    fetchCertificates({ commit }, query) {
      let url = `/projects/${projectId()}/certificates?PageIndex=${
        query.pageIndex
      }&PageSize=${query.pageSize}`
      url += query.filter ? '&Status=1&Status=7' : ''
      commit('SET_FETCHING_CERTIFICATES', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(url)
          .then(response => {
            commit('SET_CERTIFICATES', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_CERTIFICATES', false)
          })
      })
    },

    fetchSniCertificates({ commit }) {
      commit('SET_FETCHING_SNI_CERTIFICATES', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(`/projects/${projectId()}/certificates/sni`)
          .then(response => {
            commit('SET_SNI_CERTIFICATES', response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_SNI_CERTIFICATES', false)
          })
      })
    },

    fetchAutoValidatableDomains({ commit }) {
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(`/projects/${projectId()}/certificates/auto-validatable/domains`)
          .then(response => {
            commit('SET_AUTOVALIDATABLE_DOMAINS', response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    addCertificate({ commit }, certificate) {
      commit('SET_ADDING_CERTIFICATE', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .post(`/projects/${projectId()}/certificates`, certificate)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_ADDING_CERTIFICATE', false)
          })
      })
    },

    updateCertificate({ commit }, certificate) {
      commit('SET_UPDATING_CERTIFICATE', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .put(`/projects/${projectId()}/certificates/${certificate.id}`, {
            scopeId: certificate.scopeId,
          })
          .then(response => {
            commit('UPDATE_CERTIFICATE', certificate)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_CERTIFICATE', false)
          })
      })
    },

    removeCertificate({ commit }, certificateId) {
      commit('SET_REMOVING_CERTIFICATE', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .delete(`/projects/${projectId()}/certificates/${certificateId}`)
          .then(response => {
            commit('REMOVE_CERTIFICATE', certificateId)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_REMOVING_CERTIFICATE', false)
          })
      })
    },

    getCertificate({ commit }, certificateId) {
      commit('SET_GETTING_CERTIFICATE', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(`/projects/${projectId()}/certificates/${certificateId}`)
          .then(response => {
            commit('GET_CERTIFICATE', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_CERTIFICATE', false)
          })
      })
    },

    downloadCertificate({ commit }, query) {
      commit('SET_DOWNLOADING_CERTIFICATE', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(`/projects/${projectId()}/certificates/${query.certificateId}/download`, { responseType: 'blob' })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            const fileName = helperMixin.methods.getFileNameFromContentDisposition(response.headers['content-disposition'])
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_DOWNLOADING_CERTIFICATE', false)
          })
      })
    },

    importCertificate({ commit }, certificate) {
      commit('SET_IMPORTING_CERTIFICATE', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .post(`/projects/${projectId()}/certificates/import`, certificate)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_IMPORTING_CERTIFICATE', false)
          })
      })
    },

    syncCertificate({ commit }, { id, sync }) {
      commit('SET_SYNCING_CERTIFICATE', true)
      return api('cdn')
        .put(`/projects/${projectId()}/certificates/${id}/sync`, { sync })
        .finally(() => commit('SET_SYNCING_CERTIFICATE', false))
    },

    validateCertificate({ commit }, certificateId) {
      commit('SET_VALIDATING_CERTIFICATE', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .put(
            `/projects/${projectId()}/certificates/${certificateId}/validate`,
          )
          .then(response => {
            commit('UPDATE_CERTIFICATE_STATUS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_VALIDATING_CERTIFICATE', false)
          })
      })
    },

    // DISTRIBUTIONS
    fetchDistributions({ commit }, payload) {
      let query = `?PageIndex=${payload.pageIndex}&PageSize=${payload.pageSize}&State=${payload.state}`
      if (payload.term && payload.term !== null) {
        query += `&Term=${payload.term}`
      }

      commit('SET_FETCHING_DISTRIBUTION', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(`/projects/${projectId()}/distributions${query}`)
          .then(response => {
            commit('SET_DISTRIBUTIONS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_DISTRIBUTION', false)
          })
      })
    },
    fetchScrolledDistributions({ commit }, payload) {
      let query = `?PageIndex=${payload.pageIndex}&PageSize=${payload.pageSize}&State=${payload.state}`
      if (payload.term && payload.term !== null) {
        query += `&Term=${payload.term}`
      }

      commit('SET_FETCHING_SCROLLED_DISTRIBUTION', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(`/projects/${projectId()}/distributions${query}`)
          .then(response => {
            commit('PUSH_DISTRIBUTIONS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_SCROLLED_DISTRIBUTION', false)
          })
      })
    },

    addDistribution({ commit }, distribution) {
      commit('SET_ADDING_DISTRIBUTION', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .post(`/projects/${projectId()}/distributions`, distribution)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_ADDING_DISTRIBUTION', false)
          })
      })
    },

    updateDistribution({ commit }, distribution) {
      commit('SET_UPDATING_DISTRIBUTION', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .put(
            `/projects/${projectId()}/distributions/${
              distribution.distributionId
            }`,
            distribution,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_DISTRIBUTION', false)
          })
      })
    },

    removeDistribution({ commit }, distributionId) {
      commit('SET_REMOVING_DISTRIBUTION', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .delete(`/projects/${projectId()}/distributions/${distributionId}`)
          .then(response => {
            commit('REMOVE_DISTRIBUTION', distributionId)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_REMOVING_DISTRIBUTION', false)
          })
      })
    },

    getDistribution({ commit }, distributionId) {
      commit('SET_GETTING_DISTRIBUTION', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(`/projects/${projectId()}/distributions/${distributionId}`)
          .then(response => {
            commit('GET_DISTRIBUTION', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_DISTRIBUTION', false)
          })
      })
    },

    updateDistributionState({ commit }, query) {
      commit('SET_UPDATING_DISTRIBUTION_STATE', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .put(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/enable`,
            { stateId: query.stateId },
          )
          .then(response => {
            commit('UPDATE_DISTRIBUTION_STATE', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => commit('SET_UPDATING_DISTRIBUTION_STATE', false))
      })
    },

    // ERROR PAGES
    fetchErrorPages({ commit }, distributionId) {
      commit('SET_FETCHING_ERRORPAGES', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${distributionId}/errorpages`,
          )
          .then(response => {
            commit('SET_ERRORPAGES', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_ERRORPAGES', false)
          })
      })
    },

    addErrorPage({ commit }, query) {
      commit('SET_ADDING_ERRORPAGE', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .post(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/errorpages`,
            query.errorPage,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_ADDING_ERRORPAGE', false)
          })
      })
    },

    updateErrorPage({ commit }, query) {
      commit('SET_UPDATING_ERRORPAGE', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .put(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/errorpages/${query.id}`,
            query,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_ERRORPAGE', false)
          })
      })
    },

    removeErrorPage({ commit }, query) {
      commit('SET_REMOVING_ERRORPAGE', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .delete(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/errorpages/${query.id}`,
          )
          .then(response => {
            commit('REMOVE_ERRORPAGE', query.id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_REMOVING_ERRORPAGE', false)
          })
      })
    },

    getErrorPage({ commit }, query) {
      commit('SET_GETTING_ERRORPAGE', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/errorpages/${query.id}`,
          )
          .then(response => {
            commit('GET_ERRORPAGE', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_ERRORPAGE', false)
          })
      })
    },

    // INVALIDATIONS
    fetchInvalidations({ commit }, query) {
      commit('SET_FETCHING_INVALIDATIONS', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/invalidations?PageIndex=${query.pageIndex}&PageSize=${
              query.pageSize
            }`,
          )
          .then(response => {
            commit('SET_INVALIDATIONS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_INVALIDATIONS', false)
          })
      })
    },

    addInvalidation({ commit }, query) {
      commit('SET_ADDING_INVALIDATION', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .post(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/invalidations`,
            query,
          )
          .then(response => {
            commit('ADD_INVALIDATION', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_ADDING_INVALIDATION', false)
          })
      })
    },

    getInvalidation({ commit }, query) {
      commit('SET_GETTING_INVALIDATION', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/invalidations/${query.id}`,
          )
          .then(response => {
            commit('GET_INVALIDATION', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_INVALIDATION', false)
          })
      })
    },

    // ORIGINS
    fetchOrigins({ commit }, distributionId) {
      commit('SET_FETCHING_ORIGINS', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${distributionId}/origins`,
          )
          .then(response => {
            commit('SET_ORIGINS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_ORIGINS', false)
          })
      })
    },

    addOrigin({ commit }, origin) {
      commit('SET_ADDING_ORIGIN', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .post(
            `/projects/${projectId()}/distributions/${
              origin.distributionId
            }/origins`,
            origin,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_ADDING_ORIGIN', false)
          })
      })
    },

    updateOrigin({ commit }, origin) {
      commit('SET_UPDATING_ORIGIN', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .put(
            `/projects/${projectId()}/distributions/${
              origin.distributionId
            }/origins/${origin.id}`,
            origin,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_ORIGIN', false)
          })
      })
    },

    removeOrigin({ commit }, query) {
      commit('SET_REMOVING_ORIGIN', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .delete(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/origins/${query.id}`,
          )
          .then(response => {
            commit('REMOVE_ORIGIN', query.id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_REMOVING_ORIGIN', false)
          })
      })
    },

    getOrigin({ commit }, query) {
      commit('SET_GETTING_ORIGIN', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/origins/${query.originId}`,
          )
          .then(response => {
            commit('GET_ORIGIN', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_ORIGIN', false)
          })
      })
    },

    // ORIGIN GROUPS
    fetchOriginGroups({ commit }, distributionId) {
      commit('SET_FETCHING_ORIGINGROUPS', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${distributionId}/origingroups`,
          )
          .then(response => {
            commit('SET_ORIGINGROUPS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_ORIGINGROUPS', false)
          })
      })
    },

    addOriginGroup({ commit }, origingroup) {
      commit('SET_ADDING_ORIGINGROUP', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .post(
            `/projects/${projectId()}/distributions/${
              origingroup.distributionId
            }/origingroups`,
            origingroup,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_ADDING_ORIGINGROUP', false)
          })
      })
    },

    updateOriginGroup({ commit }, query) {
      commit('SET_UPDATING_ORIGINGROUP', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .put(
            `/projects/${projectId()}/distributions/${
              query.originGroup.distributionId
            }/origingroups/${query.id}`,
            query.originGroup,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_ORIGINGROUP', false)
          })
      })
    },

    removeOriginGroup({ commit }, query) {
      commit('SET_REMOVING_ORIGINGROUP', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .delete(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/origingroups/${query.id}`,
          )
          .then(response => {
            commit('REMOVE_ORIGINGROUP', query.id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_REMOVING_ORIGINGROUP', false)
          })
      })
    },

    getOriginGroup({ commit }, origingroup) {
      commit('SET_GETTING_ORIGINGROUP', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${
              origingroup.distributionId
            }/origingroups/${origingroup.id}`,
          )
          .then(response => {
            commit('GET_ORIGINGROUP', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_ORIGINGROUP', false)
          })
      })
    },

    // HEALTHCHECKS
    fetchHealthchecks({ commit }, distributionId) {
      commit('SET_FETCHING_HEALTHCHECKS', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${distributionId}/healthchecks`,
          )
          .then(response => {
            commit('SET_HEALTHCHECKS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_HEALTHCHECKS', false)
          })
      })
    },

    addHealthcheck({ commit }, query) {
      commit('SET_ADDING_HEALTHCHECK', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .post(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/healthchecks`,
            query.healthcheck,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_ADDING_HEALTHCHECK', false)
          })
      })
    },

    updateHealthcheck({ commit }, query) {
      commit('SET_UPDATING_HEALTHCHECK', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .put(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/healthchecks/${query.id}`,
            query.healthcheck,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_HEALTHCHECK', false)
          })
      })
    },

    removeHealthcheck({ commit }, query) {
      commit('SET_REMOVING_HEALTHCHECK', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .delete(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/healthchecks/${query.id}`,
          )
          .then(response => {
            commit('REMOVE_HEALTHCHECK', query.id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_REMOVING_HEALTHCHECK', false)
          })
      })
    },

    getHealthcheck({ commit }, query) {
      commit('SET_GETTING_HEALTHCHECK', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/healthchecks/${query.id}`,
          )
          .then(response => {
            commit('GET_HEALTHCHECK', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_HEALTHCHECK', false)
          })
      })
    },

    // RESTRICTIONS
    fetchRestrictions({ commit }, distributionId) {
      this.state.loading = true
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${distributionId}/restrictions`,
          )
          .then(response => {
            commit('SET_RESTRICTIONS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // SET_DELETING_RESTRICTION
    createRestriction({ commit }, { distributionId, restriction }) {
      commit('SET_CREATING_RESTRICTION', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .post(
            `/projects/${projectId()}/distributions/${distributionId}/restrictions`,
            { ...restriction },
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_CREATING_RESTRICTION', false)
          })
      })
    },

    updateRestriction(
      { commit },
      { distributionId, restriction, restrictionId },
    ) {
      commit('SET_UPDATING_RESTRICTION', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .put(
            `/projects/${projectId()}/distributions/${distributionId}/restrictions/${restrictionId}`,
            { ...restriction },
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_RESTRICTION', false)
          })
      })
    },

    deleteRestriction({ commit }, { distributionId, restrictionId }) {
      commit('SET_DELETING_RESTRICTION', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .delete(
            `/projects/${projectId()}/distributions/${distributionId}/restrictions/${restrictionId}`,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_DELETING_RESTRICTION', false)
          })
      })
    },

    getRestriction({ commit }, distributionId, restrictionId) {
      this.state.loading = true
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${distributionId}/restrictions/${restrictionId}`,
          )
          .then(response => {
            commit('GET_RESTRICTION', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // eslint-disable-next-line no-empty-pattern
    fetchRestrictionById({}, query) {
      const { distributionId, restrictionId } = query
      this.state.loading = true
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${distributionId}/restrictions/${restrictionId}`,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // TAGS
    fetchTags({ commit }, distributionId) {
      commit('SET_FETCHING_TAGS', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(`/projects/${projectId()}/distributions/${distributionId}/tags`)
          .then(response => {
            commit('SET_TAGS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => commit('SET_FETCHING_TAGS', false))
      })
    },

    addTag({ commit }, query) {
      commit('SET_UPDATING_TAGS', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .post(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/tags`,
            {
              id: query.id,
              distributionId: query.distributionId,
              key: query.key,
              value: query.value,
            },
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => commit('SET_UPDATING_TAGS', false))
      })
    },

    updateTag({ commit }, query) {
      commit('SET_UPDATING_TAGS', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .put(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/tags/${query.tag.id}`,
            { tag: query.tag },
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => commit('SET_UPDATING_TAGS', false))
      })
    },

    removeTag({ commit }, query) {
      commit('SET_UPDATING_TAGS', true)
      return new Promise((resolve, reject) => {
        api('cdn')
          .delete(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/tags/${query.id}`,
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => commit('SET_UPDATING_TAGS', false))
      })
    },

    getTag({ commit }, query) {
      return new Promise((resolve, reject) => {
        api('cdn')
          .get(
            `/projects/${projectId()}/distributions/${
              query.distributionId
            }/tags/${query.id}`,
          )
          .then(response => {
            commit('GET_TAG', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
